import React, { useEffect, useReducer, useState } from 'react';
import { DateTime } from 'luxon';
import Camera, { FACING_MODES, IMAGE_TYPES } from 'react-html5-camera-photo';
import 'react-html5-camera-photo/build/css/index.css';
import { Box, Fab, IconButton, Modal } from '@mui/material';
import { AddAPhoto, ChevronLeft } from '@mui/icons-material';
import { photos } from 'config/photos';
import { dataURLtoFile } from 'utils/common';


type PhotoButtonProps = {
    onFinish: (photo: File) => void,
    inline?: boolean,
}

const PhotoMaker = ({ onFinish, inline }: PhotoButtonProps) => {
    const [open, toggle] = useReducer(open => !open, false);
    const [landscape, setLandscape] = useState(window.innerHeight < window.innerWidth);

    const addPhoto = (dataUri: string) => {
        const now = DateTime.now().toFormat('yyLLdd_HHmmss');
        onFinish(dataURLtoFile(dataUri, `IMG_${now}.jpg`));
    };

    useEffect(() => {
        const change = (e: any) => setLandscape(e.target.innerHeight > e.target.innerWidth)
        window.addEventListener('orientationchange', change);
        return () => {window.removeEventListener('orientationchange', change)}
    }, []);

    return (
        <>
            {inline ?
                <IconButton
                    onClick={toggle}
                    aria-label="make picture"
                    size="large"
                    color="primary"
                >
                    <AddAPhoto fontSize="large"/>
                </IconButton>
                :
                <Fab
                    color="primary"
                    aria-label="make picture"
                    sx={{
                        position: "fixed",
                        bottom: (theme) => theme.spacing(2),
                        right: (theme) => theme.spacing(2)
                    }}
                    onClick={toggle}
                >
                    <AddAPhoto/>
                </Fab>
            }

            <Modal
                open={open}
                onClose={toggle}
                sx={{bgcolor: 'black'}}
            >
                <Box sx={landscape ? {
                    '#container-circles': {
                            right: '15%',
                            left: 'auto',
                            bottom: '55%',
                        },
                    'video': {
                        width: 'auto',
                        height: '100vh',
                    },
                } : {}}>
                    <Fab
                        size="small"
                        sx={{position: 'fixed', zIndex: 1300, top: 8, left: 8}}
                        onClick={toggle}
                    >
                        <ChevronLeft fontSize="small" />
                    </Fab>

                    <Camera
                        onTakePhoto={addPhoto}
                        imageType={IMAGE_TYPES.JPG}
                        imageCompression={photos.compression}
                        idealFacingMode={FACING_MODES.ENVIRONMENT}
                        idealResolution={{
                            width: photos.largerSide,
                            height: photos.smallerSide,
                        }}
                    />
                </Box>
            </Modal>
        </>
    );
};

export default PhotoMaker;
